import M from 'materialize-css';



//for refreshing all select tags in a page...
export function refreshSelectDropdown(page) {

    page.$nextTick(function() {
        const selectDropdown = document.querySelectorAll('select');

        M.FormSelect.init(selectDropdown);
    });
}